import logo from '../../assets/img/logo-elecciones-colombia.png';
import logomex from '../../assets/img/logo-elecciones-mexico_horizontal.png';
import logobr from '../../assets/img/logo-eleccion-brasil-light.png';
import logoPe from '../../assets/img/logo-eleccion-peru-light.png';
import logobrDrk from '../../assets/img/logo-eleccion-brasil-dark.png';
import logoPeDrk from '../../assets/img/logo-eleccion-peru-dark.png';
import './PresiResume.scss';

const PresiResume = ({ votes, country, shortVersion = false, theme, formatNumber }) => {

  const srcLogo = () => {
    let logoUrl = logo;
    switch(country) {
      case 'méxico':
        logoUrl = logomex;
        break;
      case 'brasil':
        if(theme === 'dark') {
          logoUrl = logobrDrk;
          break;
        }
        logoUrl = logobr;
        break;
      case 'perú':
        if(theme === 'dark') {
          logoUrl= logoPeDrk;
          break;
        }
        logoUrl = logoPe;
        break;
      default:
        return logoUrl;
    };
    return logoUrl;
  }
  //const srcLogo = country === 'mex' ? logomex : logo;
  const classVersion = shortVersion ? '-short' : '';
  
  return (
    <div>
      <section className="p-resume">
        <div className="p-resume__logo">
          <img className="p-resume__logo-img" src={srcLogo()} alt="Elecciones colombia" />
        </div>

        <div className={`p-resume__desktop-separator${classVersion}`}></div>
        <div className={`p-resume__votes${classVersion}`}>
          <div className={`p-resume__votes-top${classVersion}`}>
            <div className="p-resume__votes-data">
              VOTOS TOTALES <span> {formatNumber ? votes.votesTotal : votes?.votesTotal?.replaceAll(',', '.')} </span>
            </div>
          </div>
          <div className={`p-resume__separator${classVersion}`}></div>
          <div className={`p-resume__votes-bot${classVersion}`}>
            <div className={`p-resume__votes-data${classVersion}`}>
              VOTOS NULOS <span> {formatNumber ? votes.votesAnnulled : votes?.votesAnnulled?.toString().replaceAll(',', '.')} </span>
            </div>
            <div className={`p-resume__votes-separator${classVersion}`}></div>
            <div className={`p-resume__votes-data${classVersion}`} >
              VOTOS EN BLANCO <span> {formatNumber ? votes.votesBlank : votes?.votesBlank?.toString().replaceAll(',', '.')} </span>
            </div>
            <div className="p-resume__votes-separator"></div>
            <div className="p-resume__votes-data">
              MESAS ESCRUTADAS <span> {formatNumber ? votes.votesInvalid : votes?.votesInvalid?.toString().replaceAll('.', ',')}% </span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PresiResume;
